import { conformsTo, isString, isNumber, get, trim, first } from 'lodash';

import { StudentProfileEnum as SPE } from 'Common/FieldEnum';
import { ChargePermissionEnum } from 'Common/Constants/ChargePermissions';
import MPWWebAPI from 'API/MPWApi';
import { sortByLastNameFirstName } from 'PointOfSale/modules/common/helpers';
import { SearchStatuses } from 'PointOfSale/modules/common/constants';
import { GENERIC_ACCOUNT_IDS } from 'Common/Constants';
import { getStudents } from 'PointOfSale/state/actions';

export const canChargeAccount = (profile) => {
  return Object.values(ChargePermissionEnum)
    .filter((p) => p !== ChargePermissionEnum.N)
    .some((p) => p === getChargeStatus(profile));
};

export const getChargeStatus = (profile) => {
  return get(profile, SPE.Charge);
};

export const isValidProfile = (profile) =>
  conformsTo(profile, {
    [SPE.Id]: (v) => isNumber(v) || isString(v),
    [SPE.IdSeed]: (v) => isNumber(v) || isString(v),
    [SPE.FirstName]: isString,
    [SPE.LastName]: isString,
    [SPE.StatusCurrent]: (v) => isNumber(v) || isString(v),
    [SPE.GradeId]: (v) => isNumber(v) || isString(v),
  });

/**
 * Checks if a student is a visiting student
 * @param {String} studentSiteId
 * @param {Array<String>} siteIds
 */
export const isVisitingStudent = (studentSiteId, siteIds) => {
  return !siteIds.includes(studentSiteId);
};

/**
 * searches for a student, returns the first result that matches student's Id or ServingNumber
 * @param {String} search
 * @returns {Object}
 */
export const searchStudents = async (search) => {
  try {
    const query = trim(search) || '';

    const students = await getStudents({ search: query, MPWWebAPI });

    const filteredResults = sortByLastNameFirstName(
      students.filter(
        (student) =>
          SearchStatuses.includes(student.StatusCurrent) &&
          !GENERIC_ACCOUNT_IDS.has(student.Id) &&
          (query === student.Id || query === student.ServingNumber)
      )
    );

    return first(filteredResults);
  } catch (ex) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/helpers/profile.js